module.exports = __webpack_public_path__ + "static/media/banner_oquefalam_03-small.6066ee49.png";